import { render, staticRenderFns } from "./academic-form.vue?vue&type=template&id=fae9ef5e&"
import script from "./academic-form.vue?vue&type=script&lang=js&"
export * from "./academic-form.vue?vue&type=script&lang=js&"
import style0 from "./academic-form.vue?vue&type=style&index=0&id=fae9ef5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports